import { differenceInMinutes } from 'date-fns'
import { roundNumber } from './number'

/**
 * @returns {string} the user's local timezone e.g. America/Los_Angeles
 */
export const getLocalTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getLongDuration = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const mins = roundNumber(minutes % 60, 2)
  // Manually constructing the duration string
  const formattedDuration = [
    hours ? `${hours} hrs` : '', // Include hours part only if it's non-zero
    mins ? `${mins} mins` : '', // Include minutes part only if it's non-zero
  ]
    .filter(Boolean)
    .join(' ') // Join non-empty parts with space, removing any potential empty strings

  return formattedDuration
}

export const getDurationInHours = (
  start: Date | string,
  end: Date | string
) => {
  const durationInMinutes = differenceInMinutes(end, start)
  const durationInHours = durationInMinutes / 60
  const roundedDurationInHours = roundNumber(durationInHours, 3)
  return roundedDurationInHours
}

/**
 * Calculate working hours excluding unpaid breaks
 * @param start - shift start time
 * @param end - shift end time
 * @param lunchBreak - optional lunch break information
 * @returns working hours (excluding unpaid breaks)
 */
export const getWorkingHours = (
  start: Date | string,
  end: Date | string,
  lunchBreak?: { type: 'paid' | 'unpaid'; durationInMinutes: number }
) => {
  const totalDurationInMinutes = differenceInMinutes(end, start)

  // Subtract unpaid break time
  const unpaidBreakMinutes =
    lunchBreak?.type === 'unpaid' ? lunchBreak.durationInMinutes : 0
  const workingMinutes = totalDurationInMinutes - unpaidBreakMinutes

  const workingHours = workingMinutes / 60
  return roundNumber(workingHours, 3)
}
